module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "only-flex"
  }, [_c('race-header', {
    attrs: {
      "subtitle": _vm.subtitle
    }
  }), _vm._v(" "), _vm._l((_vm.races), function(race) {
    return _c('race-item', {
      key: race.id,
      attrs: {
        "type": _vm.type,
        "info": race
      }
    })
  }), _vm._v(" "), (_vm.races.length === 0) ? _c('div', {
    staticClass: "race__empty"
  }, [_vm._v("\n    " + _vm._s(_vm.messageEmptyList) + "\n  ")]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-61042474"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Race/RaceList.vue
// module id = 1828
// module chunks = 1